import { useEffect, useMemo, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import * as THREE from "three";
import { addEventListener } from "../src/events/eventBus";

export default function Gifts({
  position = [13.91, 2.26, 49.46],
  rotation = [0, 0, 0],
  scale = 1,
  ...rigidBodyProps
}) {
  const { scene } = useGLTF("/gifts.glb");
  const giftsScene = useMemo(() => scene.clone(true), [scene]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    giftsScene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.castShadow = true;
        child.receiveShadow = true;
      }
    });
  }, [giftsScene]);

  useEffect(() => {
    const unsubscribe = addEventListener("playCake", () => {
      setVisible(true);
    });

    return () => unsubscribe();
  }, []);

  if (!visible) return null;

  return (
    <RigidBody
      type="fixed"
      colliders="trimesh"
      position={position}
      rotation={rotation}
      {...rigidBodyProps}
    >
      <group scale={scale}>
        <primitive object={giftsScene} />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/gifts.glb");
